import React, { useEffect, useState } from 'react';
import { Tabs } from 'antd';
import { Outlet, useNavigate } from 'react-router-dom';

import { Page } from 'shared/ui/Page';
import getEnvConfig from 'utils/config/env';

import { tabs } from '../../components/Chats/utils/tabs';

const pageSlug = 'communities-current-page';

export const CommunitiesPage = () => {
    const navigate = useNavigate();

    const [tab, setTab] = useState(
        sessionStorage.getItem(pageSlug) || 'manage'
    );

    useEffect(() => {
        sessionStorage.setItem(pageSlug, tab);
        navigate(`${getEnvConfig().PUBLIC_PATH}/communities/${tab}`);
    }, [tab]);

    return (
        <Page title='Сообщества'>
            <Tabs activeKey={tab} onChange={setTab} items={tabs} />
            <Outlet />
        </Page>
    );
};
